// 9fbef606107a605d69c0edbcd8029e5d
import LOGINPAGE_CONSTANTS from '../LoginPage.constants';

export const login = (payload, afterLoginHandler, fromForgotPassword, fromPlcc) => {
  return {
    type: LOGINPAGE_CONSTANTS.LOGIN,
    payload,
    afterLoginHandler,
    fromForgotPassword,
    fromPlcc,
  };
};

export const setEmailRetryCount = (payload) => {
  return {
    payload,
    type: LOGINPAGE_CONSTANTS.SET_EMAIL_RETRY_COUNT,
  };
};

export const emailSubmit = (payload) => {
  return {
    type: LOGINPAGE_CONSTANTS.EMAIL_SUBMIT,
    payload,
  };
};

export const setExistingUserResponse = (payload) => {
  return {
    payload,
    type: LOGINPAGE_CONSTANTS.SET_EXISTING_USER_RESPONSE,
  };
};

export const loginToSFCC = (payload) => {
  return {
    type: LOGINPAGE_CONSTANTS.LOGIN_SFCC,
    payload,
  };
};

export const setLoginModalMountedState = (payload) => {
  return {
    type: LOGINPAGE_CONSTANTS.LOGIN_MODAL_MOUNTED_STATE,
    payload,
  };
};
export const setLoginLoadingState = (payload) => {
  return {
    payload,
    type: LOGINPAGE_CONSTANTS.SET_LOGIN_LOADING_STATE,
  };
};

export const setPlccLoginLoadingState = (payload) => {
  return {
    payload,
    type: LOGINPAGE_CONSTANTS.SET_PLCC_LOGIN_LOADING_STATE,
  };
};

export const resetLoginInfo = (payload) => {
  return {
    type: LOGINPAGE_CONSTANTS.RESET_LOGIN_INFO,
    payload,
  };
};

export const setCheckoutModalMountedState = (payload) => {
  return {
    type: LOGINPAGE_CONSTANTS.CHECKOUT_MODAL_MOUNTED_STATE,
    payload,
  };
};

export const setCountryCode = (payload) => {
  return {
    type: LOGINPAGE_CONSTANTS.SET_COUNTRY_CODE,
    payload,
  };
};

export const setLoginInfo = (payload) => {
  return {
    type: LOGINPAGE_CONSTANTS.SET_LOGIN_INFO,
    payload,
  };
};

export const getOrderDetail = () => {
  return {
    type: 'GET_ORDER_DETAIL',
  };
};

export const setMaskedPhoneNumber = (payload) => {
  return {
    payload,
    type: LOGINPAGE_CONSTANTS.MASKED_PHONE_NUMBER,
  };
};

export const setShowPhoneLoginOption = (payload) => {
  return {
    payload,
    type: LOGINPAGE_CONSTANTS.SHOW_PHONE_LOGIN_OPTION,
  };
};

export const generateLoginOTP = (payload) => {
  return {
    type: LOGINPAGE_CONSTANTS.GENERATE_LOGIN_OTP,
    payload,
  };
};

export const setShowOTPInputScreen = (payload) => {
  return {
    type: LOGINPAGE_CONSTANTS.SHOW_OTP_INPUT_SCREEN,
    payload,
  };
};

export const setOTPToken = (payload) => {
  return {
    type: LOGINPAGE_CONSTANTS.OTP_TOKEN,
    payload,
  };
};

export const setUserNotExist = (payload) => {
  return {
    type: LOGINPAGE_CONSTANTS.USER_NOT_EXIST,
    payload,
  };
};

export const setLoginSelectedOption = (payload) => {
  return {
    type: LOGINPAGE_CONSTANTS.LOGIN_SELECTION_OPTION,
    payload,
  };
};

export const setIsOtpLimit = (payload) => {
  return {
    type: LOGINPAGE_CONSTANTS.IS_OTP_LIMIT,
    payload,
  };
};

export const showEmailFormScreen = (payload) => {
  return {
    type: LOGINPAGE_CONSTANTS.SHOW_EMAIL_FORM_SCREEN,
    payload,
  };
};

export const setIsLocked = (payload) => {
  return {
    type: LOGINPAGE_CONSTANTS.IS_LOCKED,
    payload,
  };
};
